// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-logo{width:88px;height:64px}@media (min-width:1024px){.p-logo{width:240px;height:64px}}.p-logo__desktop,.p-logo__mobile{width:100%;height:100%}@media (min-width:1024px){.p-logo__mobile{display:none}}.p-logo__desktop{display:none}@media (min-width:1024px){.p-logo__desktop{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
